import Link from "next/link";

const GROUP_LOGOS = [
  { name: "Yuva Foundation", initials: "YF" },
  { name: "Yuva GPT", initials: "GPT" },
  { name: "Yuva Marg", initials: "YM" },
  { name: "Yuva FM", initials: "FM" },
  { name: "Yuva Hire", initials: "YH" },
  { name: "Mauli Navnirman", initials: "MN" },
  { name: "NAREDCO Vidarbha", initials: "NV" },
  { name: "BNI", initials: "BNI" },
];

const MARQUEE_ITEMS = [...GROUP_LOGOS, ...GROUP_LOGOS];

const OurGroupRibbon = () => {
  return (
    <section className="our-group-ribbon">
      <div className="container">
        <div className="our-group-ribbon__heading">
          <h2>Part of the Siddhivinayak Group</h2>
          <div className="our-group-ribbon__underline">
            <span></span>
            <span></span>
            <span className="is-active"></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <div className="our-group-ribbon__track-wrap">
        <div className="our-group-ribbon__track">
          {MARQUEE_ITEMS.map((logo, idx) => (
            <Link
              href="#"
              className="our-group-ribbon__item"
              key={`${logo.name}-${idx}`}
              title={logo.name}
            >
              <span className="our-group-ribbon__icon">
                <span className="our-group-ribbon__initials">
                  {logo.initials}
                </span>
              </span>
              <span className="our-group-ribbon__label">{logo.name}</span>
            </Link>
          ))}
        </div>
      </div>

      <style jsx>{`
        .our-group-ribbon {
          padding: 70px 0 60px;
          background: #ffffff;
          overflow: hidden;
        }
        .our-group-ribbon__heading {
          text-align: center;
          margin-bottom: 40px;
        }
        .our-group-ribbon__heading h2 {
          font-family: Georgia, "Times New Roman", serif;
          font-weight: 700;
          font-size: 34px;
          color: #1a1a2e;
          margin: 0 0 12px;
        }
        .our-group-ribbon__underline {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 6px;
        }
        .our-group-ribbon__underline span {
          display: inline-block;
          height: 3px;
          width: 22px;
          background: #e2ddd4;
          border-radius: 2px;
        }
        .our-group-ribbon__underline span.is-active {
          width: 34px;
          background: #d98c3f;
        }
        .our-group-ribbon__track-wrap {
          width: 100%;
          overflow: hidden;
          -webkit-mask-image: linear-gradient(
            to right,
            transparent 0,
            #000 60px,
            #000 calc(100% - 60px),
            transparent 100%
          );
          mask-image: linear-gradient(
            to right,
            transparent 0,
            #000 60px,
            #000 calc(100% - 60px),
            transparent 100%
          );
        }
        .our-group-ribbon__track {
          display: flex !important;
          align-items: flex-start !important;
          width: max-content !important;
          gap: 56px !important;
          animation: our-group-scroll 32s linear infinite;
        }
        .our-group-ribbon__track:hover {
          animation-play-state: paused;
        }
        .our-group-ribbon__item {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          text-decoration: none !important;
          flex: 0 0 auto !important;
          width: 130px !important;
          margin: 0 !important;
        }
        .our-group-ribbon__icon {
          width: 100px;
          height: 100px;
          border-radius: 16px;
          background: #f4f4f4;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .our-group-ribbon__item:hover .our-group-ribbon__icon {
          transform: translateY(-4px);
          box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
        }
        .our-group-ribbon__initials {
          font-family: Georgia, "Times New Roman", serif;
          font-weight: 700;
          font-size: 20px;
          letter-spacing: 0.5px;
          color: #d98c3f;
        }
        .our-group-ribbon__label {
          display: block !important;
          margin-top: 14px;
          font-size: 14px;
          font-weight: 500;
          color: #55575c;
          text-align: center;
          white-space: nowrap;
        }
        @keyframes our-group-scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }
        @media (max-width: 767px) {
          .our-group-ribbon {
            padding: 50px 0 40px;
          }
          .our-group-ribbon__heading h2 {
            font-size: 26px;
          }
          .our-group-ribbon__icon {
            width: 80px;
            height: 80px;
          }
          .our-group-ribbon__item {
            width: 100px !important;
          }
          .our-group-ribbon__track {
            gap: 32px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default OurGroupRibbon;